import { address } from './address'
import { order } from './order'

export const api = {
  address,
  order,
}
